/* eslint-disable */

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const PIN_SUMMARY       = '#728bdf';
const SUMMARY_TOLERANCE = 0.00001;

// Must stay in sync with FEATURED_LOCATIONS in 1916-map.js — update both together.
const FEATURED_LOCATIONS = [
    {
        storyname: "South Dublin Union",
        location: "South Dublin Union, James's Street, Dublin",
        latitude: "53.3431735",
        longitude: "-6.2902600",
        slug: "south-dublin-union",
        image: '/uploads/images/1916-guides-South-Dublin-Union-entrance-BMH-1952.jpg',
    },
    {
        storyname: "Jacob's Factory",
        location: "Jacob's Biscuit Factory, Bishop Street, Dublin",
        latitude: "53.3383462",
        longitude: "-6.2677148",
        slug: "jacobs-factory",
        image: '/uploads/images/1916Places-Jacobs1.jpg',
    },
    {
        storyname: "Area of Boland’s Mills/Bakery",
        location: "Boland's Bakery/Boland's Mills, Grand Canal Street, Dublin",
        latitude: "53.3420795",
        longitude: "-6.2371632",
        slug: "bolands-mills",
        image: '/uploads/images/IE-MA-BMH-P-32-004.jpg',
    },
    {
        storyname: "Little's Public House, Harcourt Street, Dublin",
        location: "Little's Public House, Harcourt Street, Dublin",
        latitude: "53.3376300",
        longitude: "-6.2629000",
        slug: "littles-public-house-harcourt-street-dublin",
        image: '/uploads/images/IE-MA-BMH-P-36-063.jpg',
    },
    {
        storyname: "Kinvara, County Galway",
        location: "Kinvara, County Galway",
        latitude: "53.1389085",
        longitude: "-8.9362964",
        slug: "kinvara-county-galway",
        image: '/uploads/images/A21-_4_A-Galway-Easter-Week-1916.jpg-66.jpg',
    },
    {
        storyname: "County Galway",
        location: "County Galway",
        latitude: "53.3564509",
        longitude: "-8.8534113",
        slug: "county-galway",
        image: '/uploads/images/A21-_4_A-Galway-Easter-Week-1916.jpg-65.jpg',
    },
    {
        storyname: "Father Matthew Hall",
        location: "Father Matthew Hall, Church Street, Dublin",
        latitude: "53.3494298",
        longitude: "-6.2749072",
        slug: "father-matthew-hall",
        image: '/uploads/images/FatherMatHall.jpg',
    },
    {
        storyname: "Liberty Hall",
        location: "Liberty Hall, Beresford Place, Dublin",
        latitude: "53.3484728",
        longitude: "-6.2556986",
        slug: "liberty-hall",
        image: '/uploads/images/liberty-hall.jpg',
    },
    {
        storyname: "The Battle of Ashbourne",
        location: "Ashbourne, County Meath",
        latitude: "53.5106742",
        longitude: "-6.3969054",
        slug: "ashbourne-1916",
        image: '/uploads/images/Thomas_Ashe_-_portrait_photograph_2026-04-02-145219_jarc.jpg',
    },
    {
        storyname: "Area of Church Street, Dublin",
        location: "Church Street, Dublin",
        latitude: "53.346486",
        longitude: "-6.275262",
        slug: "father-matthew-hall",
        image: '/uploads/images/FatherMatHall.jpg',
    },
    {
        storyname: "Metropole Hotel, O'Connell Street, Dublin",
        location: "Metropole Hotel, O'Connell Street, Dublin",
        latitude: "53.3488674",
        longitude: "-6.26031972",
        slug: "metropole-hotel-oconnell-street-dublin",
        image: '/uploads/images/IE-MA-BMH-P-31-015.jpg',
    },
    {
        storyname: "Mount Street",
        location: "Mount Street, Dublin",
        latitude: "53.3385739",
        longitude: "-6.2433888",
        slug: "mount-street",
        image: '/uploads/images/IE-MA-BMH-P-31-015.jpg',
    },
    {
        storyname: "Davy's Public House",
        location: "Davy's Public House, 42 Lower Camden Street, Dublin",
        latitude: "53.3305",
        longitude: "-6.26391",
        slug: "davys-public-house",
        image: '/uploads/images/Davys-Pub.jpg',
    }
];

const storySlug = window.locationStorySlug;
console.log("story slug: " + storySlug);
const summary   = FEATURED_LOCATIONS.find(f => f.slug === storySlug) || null;

if (!summary) {
    console.warn(
        '[1916-location-story] No featured location matched for slug:', storySlug,
        '— known slugs:', FEATURED_LOCATIONS.map(f => f.slug)
    );
}

// ── Map ───────────────────────────────────────────────────────────────────────
// Always initialise the map — if no summary matched, fall back to Dublin centre.
const MAPBOX_TOKEN = 'pk.eyJ1Ijoic2VhbmNvbjczIiwiYSI6ImNtbWF1eGV2OTBnbWgycnNkOGxmaDEwbzcifQ.BdNcGJ_7H_aj9YTmmYIWfg';
const MAPBOX_STYLE = 'seancon73/cmmdnwa32009s01sk6jku8zqz';

const defaultView = summary ? [parseFloat(summary.latitude), parseFloat(summary.longitude)] : [53.3498, -6.2603];

const map = L.map('map-1916-single', { zoomControl: true, scrollWheelZoom: false })
    .setView(defaultView, 18);

L.tileLayer(`https://api.mapbox.com/styles/v1/${MAPBOX_STYLE}/tiles/256/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`, {
    attribution: '&copy; <a href="https://www.mapbox.com/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    tileSize: 256,
    maxZoom: 19,
}).addTo(map);

if (summary) {
    // Large summary-style pin (matches 1916-map.js summary icon)
    const icon = L.divIcon({
        className: '',
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 48" width="32" height="48">
            <path d="M16 0C7.2 0 0 7.2 0 16c0 9.6 16 32 16 32S32 25.6 32 16C32 7.2 24.8 0 16 0z"
                  fill="${PIN_SUMMARY}" stroke="white" stroke-width="2"/>
            <circle cx="16" cy="16" r="6" fill="white"/>
        </svg>`,
        iconSize:    [32, 48],
        iconAnchor:  [16, 48],
        popupAnchor: [0, -52],
    });

    L.marker([parseFloat(summary.latitude), parseFloat(summary.longitude)], { icon })
        .bindPopup(`<strong>${summary.location}</strong>`)
        .addTo(map);
}

window.addEventListener('load', () => map.invalidateSize());

// ── Table ─────────────────────────────────────────────────────────────────────
// Only runs when showLocationTable is true (tbody is present in the DOM) and a
// summary location was matched so we know which records to filter.
const tbody = document.getElementById('locations-1916-location-tbody');
if (tbody && summary && window.locations1916ApiUrl) {
    const PAGE_SIZE = 20;
    const STAR_ICON = `<span class="featured-star" title="Featured story" aria-label="Featured">&#9733;</span>`;

    let locationRows = [];   // all records at this summary location
    let filteredRows = [];   // after name filter applied
    let visibleCount = 0;

    function buildRow(loc) {
        const tr = document.createElement('tr');
        const refCell = loc.reference_code
            ? `<a href="http://mspcsearch.militaryarchives.ie/dispatcher.aspx?action=detail&database=pensions&priref=${loc.reference_code}">View MSPC record</a>`
            : '';
        tr.innerHTML = `
            <td><a href="${loc.view_url}">${loc.name || ''}</a></td>
            <td>${loc.organisation || ''}</td>
            <td>${loc.gender || ''}</td>
            <td>${refCell}</td>
            <td>${loc.featured == 1 ? STAR_ICON : ''}</td>
        `;
        tr.querySelectorAll('a').forEach(a => a.addEventListener('click', e => e.stopPropagation()));
        return tr;
    }

    function updateLoadMore() {
        const btn = document.getElementById('load-more-1916-location');
        if (btn) btn.style.display = visibleCount < filteredRows.length ? '' : 'none';
    }

    function renderRows(rows) {
        filteredRows = rows;
        visibleCount = 0;
        tbody.innerHTML = '';
        const slice = rows.slice(0, PAGE_SIZE);
        slice.forEach(loc => tbody.appendChild(buildRow(loc)));
        visibleCount = slice.length;
        updateLoadMore();
    }

    function applyNameFilter() {
        const val = (document.getElementById('filter-location-name')?.value || '').trim().toLowerCase();
        renderRows(val
            ? locationRows.filter(loc => (loc.name || '').toLowerCase().includes(val))
            : locationRows
        );
    }

    document.getElementById('filter-location-name')?.addEventListener('input', applyNameFilter);

    document.getElementById('load-more-1916-location')?.addEventListener('click', () => {
        const slice = filteredRows.slice(visibleCount, visibleCount + PAGE_SIZE);
        slice.forEach(loc => tbody.appendChild(buildRow(loc)));
        visibleCount += slice.length;
        updateLoadMore();
    });

    fetch(window.locations1916ApiUrl)
        .then(r => r.json())
        .then(data => {
            locationRows = data.filter(loc => {
                const pairs = [{ lat: loc.latitude, lng: loc.longitude }];
                for (let i = 2; i <= 10; i++) {
                    pairs.push({ lat: loc[`latitude_${i}`], lng: loc[`longitude_${i}`] });
                }
                return pairs.some(({ lat, lng }) => {
                    const latF = parseFloat(lat), lngF = parseFloat(lng);
                    return !isNaN(latF) && !isNaN(lngF) &&
                        Math.abs(latF - parseFloat(summary.latitude)) < SUMMARY_TOLERANCE &&
                        Math.abs(lngF - parseFloat(summary.longitude)) < SUMMARY_TOLERANCE;
                });
            });
            renderRows(locationRows);
        })
        .catch(err => console.error('1916 locations API error:', err));
}

/* eslint-enable */
